// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DespatchDialog_featuredInteractionLogDialogItem__m3vCm {
    flex: 1 1;
    margin: 0px 20px;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
    vertical-align: top;
}

.DespatchDialog_featured__p7yn2 {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.DespatchDialog_featuredItem__yxwY1 {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.DespatchDialog_item__\\+KpXV{
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;  
    border: none;
}


.DespatchDialog_featuredTitleHeader__hDk-U {
    font-size: 17px;
    font-weight: bold;
}

.DespatchDialog_dialogInputs__02xiN {
    width: 100%;
}

.DespatchDialog_dialogReadOnlyInputs__MuHBw {
    width: 100%;
    z-index: 1000;
    pointer-events: none;
}

.DespatchDialog_columncell__H42X2 {
    vertical-align: initial;
    height: 100%;
}

.DespatchDialog_splitcolumn__Kt\\+Mf {
    min-height: 48%;
}`, "",{"version":3,"sources":["webpack://./src/components/DespatchDialog/DespatchDialog.module.css"],"names":[],"mappings":"AAAA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,kDAAkD;AACtD;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".featuredInteractionLogDialogItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    vertical-align: top;\r\n}\r\n\r\n.featured {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.item{\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;  \r\n    border: none;\r\n}\r\n\r\n\r\n.featuredTitleHeader {\r\n    font-size: 17px;\r\n    font-weight: bold;\r\n}\r\n\r\n.dialogInputs {\r\n    width: 100%;\r\n}\r\n\r\n.dialogReadOnlyInputs {\r\n    width: 100%;\r\n    z-index: 1000;\r\n    pointer-events: none;\r\n}\r\n\r\n.columncell {\r\n    vertical-align: initial;\r\n    height: 100%;\r\n}\r\n\r\n.splitcolumn {\r\n    min-height: 48%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featuredInteractionLogDialogItem": `DespatchDialog_featuredInteractionLogDialogItem__m3vCm`,
	"featured": `DespatchDialog_featured__p7yn2`,
	"featuredItem": `DespatchDialog_featuredItem__yxwY1`,
	"item": `DespatchDialog_item__+KpXV`,
	"featuredTitleHeader": `DespatchDialog_featuredTitleHeader__hDk-U`,
	"dialogInputs": `DespatchDialog_dialogInputs__02xiN`,
	"dialogReadOnlyInputs": `DespatchDialog_dialogReadOnlyInputs__MuHBw`,
	"columncell": `DespatchDialog_columncell__H42X2`,
	"splitcolumn": `DespatchDialog_splitcolumn__Kt+Mf`
};
export default ___CSS_LOADER_EXPORT___;
